import useSWR from 'swr'

import { userSettingsUrls } from '@/config/urls/userSettings'
import { PageMetadata } from '@/pages/_app'
import { get } from '@/utils/fetchers'

import { ApiResponse, User } from '@/types/index.d'

export function useLoggedUser(pageMetaData?: PageMetadata): ApiResponse<User> {
  const url = pageMetaData?.isPublic ? null : userSettingsUrls.userInfo
  const { data, error, mutate } = useSWR<User>(url, get(url), {
    shouldRetryOnError: false,
    // This revalidation also retrigger useAuth and eventually redirect the user to /login
    revalidateOnFocus: true,
  })

  return {
    data,
    error,
    isLoading: url && !data && !error,
    mutate,
  }
}
